
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal",
      function () {
        return require("private-next-pages/personal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal"])
      });
    }
  